/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { WeatherApiConfiguration } from '../weather-api-configuration';

import { GetTile$Params, getTile } from '../fn/tiles/get-tile';
import { RenderTiles$Params, renderTiles } from '../fn/tiles/render-tiles';

/**
 * Tile API
 */
@Injectable({ providedIn: 'root' })
export class TilesService extends BaseService {
   constructor(config: WeatherApiConfiguration, http: HttpClient) {
      super(config, http);
   }

   /** Path part for operation `renderTiles()` */
   static readonly RenderTilesPath = '/api/weather/tiles';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `renderTiles()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   renderTiles$Response(params: RenderTiles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
      return renderTiles(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `renderTiles$Response()` instead.
    *
    * This method sends `application/json` and handles request body of type `application/json`.
    */
   renderTiles(params: RenderTiles$Params, context?: HttpContext): Observable<void> {
      return this.renderTiles$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
   }

   /** Path part for operation `getTile()` */
   static readonly GetTilePath = '/api/weather/tiles/{providerId}/{type}/{weatherType}/{date}/{z}/{x}/{y}';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getTile()` instead.
    *
    * This method doesn't expect any request body.
    */
   getTile$Response(params: GetTile$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
      return getTile(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getTile$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getTile(params: GetTile$Params, context?: HttpContext): Observable<Blob> {
      return this.getTile$Response(params, context).pipe(map((r: StrictHttpResponse<Blob>): Blob => r.body));
   }
}
